 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"accountEstablish~accountLocation~activity~analysis~appraise~appraiseDetail~attainment~attainmentDeta~8b046235":"accountEstablish~accountLocation~activity~analysis~appraise~appraiseDetail~attainment~attainmentDeta~8b046235","accountEstablish~accountLocation~chapters~copywriting~data~detail~discuss~practiceDetail~roadshow~sc~ea66e591":"accountEstablish~accountLocation~chapters~copywriting~data~detail~discuss~practiceDetail~roadshow~sc~ea66e591","accountEstablish~accountLocation~copywriting~practice~roadshow~scenario~teams~videoClip~videoShooting":"accountEstablish~accountLocation~copywriting~practice~roadshow~scenario~teams~videoClip~videoShooting","accountEstablish~accountLocation~buildTeam~copywriting~roadshow~scenario~videoClip~videoShooting":"accountEstablish~accountLocation~buildTeam~copywriting~roadshow~scenario~videoClip~videoShooting","accountEstablish":"accountEstablish","accountLocation":"accountLocation","copywriting":"copywriting","roadshow":"roadshow","scenario":"scenario","videoClip":"videoClip","videoShooting":"videoShooting","chapters":"chapters","data":"data","detail~discuss~practiceDetail":"detail~discuss~practiceDetail","detail":"detail","discuss":"discuss","practiceDetail":"practiceDetail","practice":"practice","teams":"teams","activity":"activity","analysis":"analysis","appraise":"appraise","appraiseDetail":"appraiseDetail","attainment":"attainment","attainmentDetail":"attainmentDetail","attitude":"attitude","attitudeDetail":"attitudeDetail","autoSetExam":"autoSetExam","classCourse":"classCourse","courseDetail":"courseDetail","courseware":"courseware","evaluation":"evaluation","exam":"exam","examBank":"examBank","examDetail":"examDetail","home~setExam":"home~setExam","classSettings~home":"classSettings~home","home":"home","knowledge":"knowledge","login":"login","platformAccount":"platformAccount","practiceBank":"practiceBank","projectPractice":"projectPractice","questionBank~questionDetail~quiz~setExam":"questionBank~questionDetail~quiz~setExam","setExam":"setExam","questionBank":"questionBank","questionDetail":"questionDetail","quiz":"quiz","rank":"rank","register":"register","reviewDetail":"reviewDetail","score":"score","sign":"sign","situation":"situation","skill":"skill","skillDetail":"skillDetail","statistics":"statistics","students":"students","teamDetail":"teamDetail","testing":"testing","vote":"vote","works":"works","buildTeam":"buildTeam","accountOperation":"accountOperation","answer":"answer","classSettings":"classSettings","finalExam":"finalExam","helpCenter":"helpCenter","message":"message","pick":"pick","practicePdf":"practicePdf","python":"python","review":"review","securityQuestion":"securityQuestion","settings":"settings","statisticsDetail":"statisticsDetail","teacherEvaluation":"teacherEvaluation","video":"video"}[chunkId]||chunkId) + "." + {"accountEstablish~accountLocation~activity~analysis~appraise~appraiseDetail~attainment~attainmentDeta~8b046235":"13d85086","accountEstablish~accountLocation~chapters~copywriting~data~detail~discuss~practiceDetail~roadshow~sc~ea66e591":"5a925956","accountEstablish~accountLocation~copywriting~practice~roadshow~scenario~teams~videoClip~videoShooting":"221b743e","accountEstablish~accountLocation~buildTeam~copywriting~roadshow~scenario~videoClip~videoShooting":"f4d5dccc","accountEstablish":"daff6bf5","accountLocation":"724e79ca","copywriting":"f6bccaf0","roadshow":"eaa80c6b","scenario":"fef1e748","videoClip":"d602b267","videoShooting":"e59e4bdc","chapters":"e045b497","data":"2bc06381","detail~discuss~practiceDetail":"3508fd45","detail":"0491b63b","discuss":"37e1850a","practiceDetail":"69f196a6","practice":"a3c13f2d","teams":"217da3fa","activity":"65b4a3a5","analysis":"1a54b752","appraise":"d2b13e14","appraiseDetail":"82d6e1a1","attainment":"93ab7e1b","attainmentDetail":"d40a2003","attitude":"1134da8c","attitudeDetail":"d4e119a6","autoSetExam":"ae6f1f16","classCourse":"283df9ad","courseDetail":"cd34ce0d","courseware":"b8dd980d","evaluation":"1ac9b3d8","exam":"f4912f0e","examBank":"625f5613","examDetail":"a1723d83","home~setExam":"87c4d0a6","classSettings~home":"9a7aee48","home":"4358b756","knowledge":"9c29a3bf","login":"53ca7e90","platformAccount":"1bca3066","practiceBank":"f74427f5","projectPractice":"3486fbc0","questionBank~questionDetail~quiz~setExam":"9cacefbe","setExam":"414ecf60","questionBank":"8f55d678","questionDetail":"40c5d90a","quiz":"8560a7c3","rank":"0056bb37","register":"033dc90a","reviewDetail":"f7923c66","score":"21124617","sign":"c733f15c","situation":"0d40551a","skill":"1fab289f","skillDetail":"64f2f8c4","statistics":"b90db7ed","students":"efb0d84f","teamDetail":"189da94a","testing":"02dc3933","vote":"271c4454","works":"79fcb7fb","buildTeam":"fb9e6f00","accountOperation":"9afbdfa1","answer":"bf61669d","classSettings":"bfd947aa","finalExam":"121587a5","helpCenter":"73f6303b","message":"f550f3c7","pick":"a46e81e5","practicePdf":"b0935488","python":"e869a05f","review":"28876527","securityQuestion":"9f7781f0","settings":"97f82957","statisticsDetail":"b53f806b","teacherEvaluation":"5ea1c392","video":"e70b5320"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"accountEstablish":1,"accountLocation":1,"copywriting":1,"roadshow":1,"scenario":1,"videoClip":1,"videoShooting":1,"chapters":1,"data":1,"detail~discuss~practiceDetail":1,"detail":1,"discuss":1,"practiceDetail":1,"practice":1,"teams":1,"activity":1,"analysis":1,"appraise":1,"appraiseDetail":1,"attainment":1,"attainmentDetail":1,"attitude":1,"attitudeDetail":1,"autoSetExam":1,"classCourse":1,"courseDetail":1,"courseware":1,"evaluation":1,"exam":1,"examBank":1,"examDetail":1,"classSettings~home":1,"home":1,"knowledge":1,"login":1,"platformAccount":1,"practiceBank":1,"projectPractice":1,"questionBank~questionDetail~quiz~setExam":1,"setExam":1,"questionBank":1,"questionDetail":1,"quiz":1,"rank":1,"register":1,"reviewDetail":1,"score":1,"sign":1,"situation":1,"skill":1,"skillDetail":1,"statistics":1,"students":1,"teamDetail":1,"testing":1,"vote":1,"works":1,"buildTeam":1,"accountOperation":1,"answer":1,"classSettings":1,"finalExam":1,"helpCenter":1,"message":1,"pick":1,"practicePdf":1,"python":1,"review":1,"securityQuestion":1,"settings":1,"statisticsDetail":1,"teacherEvaluation":1,"video":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"accountEstablish~accountLocation~activity~analysis~appraise~appraiseDetail~attainment~attainmentDeta~8b046235":"accountEstablish~accountLocation~activity~analysis~appraise~appraiseDetail~attainment~attainmentDeta~8b046235","accountEstablish~accountLocation~chapters~copywriting~data~detail~discuss~practiceDetail~roadshow~sc~ea66e591":"accountEstablish~accountLocation~chapters~copywriting~data~detail~discuss~practiceDetail~roadshow~sc~ea66e591","accountEstablish~accountLocation~copywriting~practice~roadshow~scenario~teams~videoClip~videoShooting":"accountEstablish~accountLocation~copywriting~practice~roadshow~scenario~teams~videoClip~videoShooting","accountEstablish~accountLocation~buildTeam~copywriting~roadshow~scenario~videoClip~videoShooting":"accountEstablish~accountLocation~buildTeam~copywriting~roadshow~scenario~videoClip~videoShooting","accountEstablish":"accountEstablish","accountLocation":"accountLocation","copywriting":"copywriting","roadshow":"roadshow","scenario":"scenario","videoClip":"videoClip","videoShooting":"videoShooting","chapters":"chapters","data":"data","detail~discuss~practiceDetail":"detail~discuss~practiceDetail","detail":"detail","discuss":"discuss","practiceDetail":"practiceDetail","practice":"practice","teams":"teams","activity":"activity","analysis":"analysis","appraise":"appraise","appraiseDetail":"appraiseDetail","attainment":"attainment","attainmentDetail":"attainmentDetail","attitude":"attitude","attitudeDetail":"attitudeDetail","autoSetExam":"autoSetExam","classCourse":"classCourse","courseDetail":"courseDetail","courseware":"courseware","evaluation":"evaluation","exam":"exam","examBank":"examBank","examDetail":"examDetail","home~setExam":"home~setExam","classSettings~home":"classSettings~home","home":"home","knowledge":"knowledge","login":"login","platformAccount":"platformAccount","practiceBank":"practiceBank","projectPractice":"projectPractice","questionBank~questionDetail~quiz~setExam":"questionBank~questionDetail~quiz~setExam","setExam":"setExam","questionBank":"questionBank","questionDetail":"questionDetail","quiz":"quiz","rank":"rank","register":"register","reviewDetail":"reviewDetail","score":"score","sign":"sign","situation":"situation","skill":"skill","skillDetail":"skillDetail","statistics":"statistics","students":"students","teamDetail":"teamDetail","testing":"testing","vote":"vote","works":"works","buildTeam":"buildTeam","accountOperation":"accountOperation","answer":"answer","classSettings":"classSettings","finalExam":"finalExam","helpCenter":"helpCenter","message":"message","pick":"pick","practicePdf":"practicePdf","python":"python","review":"review","securityQuestion":"securityQuestion","settings":"settings","statisticsDetail":"statisticsDetail","teacherEvaluation":"teacherEvaluation","video":"video"}[chunkId]||chunkId) + "." + {"accountEstablish~accountLocation~activity~analysis~appraise~appraiseDetail~attainment~attainmentDeta~8b046235":"31d6cfe0","accountEstablish~accountLocation~chapters~copywriting~data~detail~discuss~practiceDetail~roadshow~sc~ea66e591":"31d6cfe0","accountEstablish~accountLocation~copywriting~practice~roadshow~scenario~teams~videoClip~videoShooting":"31d6cfe0","accountEstablish~accountLocation~buildTeam~copywriting~roadshow~scenario~videoClip~videoShooting":"31d6cfe0","accountEstablish":"127c9d89","accountLocation":"0a774e03","copywriting":"d21b30b3","roadshow":"1dfecce1","scenario":"84bb0bf1","videoClip":"05203994","videoShooting":"1c34e611","chapters":"bdfbfb99","data":"f7a7b71a","detail~discuss~practiceDetail":"5d134d90","detail":"2ea3b9c9","discuss":"c8c01ce2","practiceDetail":"12d8c453","practice":"73d0e200","teams":"9cef1992","activity":"ab83e9fd","analysis":"37276736","appraise":"c3cbb0a6","appraiseDetail":"29a43847","attainment":"9b3b0901","attainmentDetail":"1a4b75f9","attitude":"dd857c7c","attitudeDetail":"de630d4d","autoSetExam":"3099d4c8","classCourse":"9147b712","courseDetail":"aaef8a95","courseware":"40944c92","evaluation":"833c11b5","exam":"1b70e359","examBank":"1ce9113c","examDetail":"69bd5ba4","home~setExam":"31d6cfe0","classSettings~home":"ca73f8b6","home":"f6f3c06d","knowledge":"bca18771","login":"ebb0ce12","platformAccount":"bc5ca6ff","practiceBank":"00cb6b8f","projectPractice":"87146783","questionBank~questionDetail~quiz~setExam":"9d84e21d","setExam":"81a6d38e","questionBank":"3dc969ac","questionDetail":"b4c3f9aa","quiz":"f13c8343","rank":"e0def50a","register":"889c7040","reviewDetail":"27e80783","score":"bc148692","sign":"4cd573b1","situation":"1138c57a","skill":"d04c87d2","skillDetail":"3efae7a6","statistics":"d34181f6","students":"ccced3ec","teamDetail":"2f8c54d5","testing":"53dafa47","vote":"b4e48ab6","works":"3b28400f","buildTeam":"fac279ab","accountOperation":"59760ac9","answer":"8354df2f","classSettings":"108ad19e","finalExam":"b6d59e41","helpCenter":"6b3a5abb","message":"c3acc63f","pick":"567a5144","practicePdf":"f3dc47ff","python":"f6794740","review":"515da88e","securityQuestion":"e64196b0","settings":"87b43ce8","statisticsDetail":"a3467268","teacherEvaluation":"3d848126","video":"402758d2"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/teacher/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
